import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingConceptAttributeType,
    getConceptAttributeTypeById,
    saveConceptAttributeType,
    deleteConceptAttributeType
} from "app/services/ConceptAttributeTypeService";
import { ConceptAttributeType } from "app/common/Model/ConceptAttributeType";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class ConceptAttributeTypeStore {
    searchConceptAttributeType = new SearchObject();
    pageConceptAttributeType = null;
    selectedConceptAttributeType = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteConceptAttributeType = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingConceptAttributeType = () => {
        pagingConceptAttributeType(this.searchConceptAttributeType).then(({ data }) => {
            this.pageConceptAttributeType = data;
        })
    }

    handleChangeFormSearch = (searchConceptAttributeType) => {
        this.searchConceptAttributeType = checkSearchObject(this.searchConceptAttributeType, searchConceptAttributeType);
        this.pagingConceptAttributeType();
    }

    handleOpenFormCreateOrEdit = (conceptAttributeTypeId) => {
        if (Boolean(conceptAttributeTypeId)) {
            getConceptAttributeTypeById(conceptAttributeTypeId).then(({ data }) => {
                this.selectedConceptAttributeType = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedConceptAttributeType = new ConceptAttributeType();
            this.openFormCreateOrEdit = true;
        }
    }

    saveConceptAttributeType = (conceptAttributeType, { setSubmitting }) => {
        saveConceptAttributeType(conceptAttributeType).then(() => {
            this.selectedConceptAttributeType = null;
            toast.success("Lưu thành công!");
            this.handleClosePopup();
            this.pagingConceptAttributeType()
        }).finally(() => setSubmitting(false))
    }

    handleDeleteConceptAttributeType = (conceptAttributeType) => {
        this.selectedConceptAttributeType = { id: conceptAttributeType?.id };
        this.openConfirmDeleteConceptAttributeType = true;
    }

    handleConfirmDeleteConceptAttributeType = async () => {
        return await deleteConceptAttributeType(this.selectedConceptAttributeType.id).then(() => {
            if (this.searchConceptAttributeType.pageIndex > 1 && this.pageConceptAttributeType.content.length === 1) {
                this.searchConceptAttributeType.pageIndex -= 1;
            }
            toast.success("Xóa loại thuộc tính thành công!")
            this.handleClosePopup();
            this.pagingConceptAttributeType();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa loại thuộc tính thất bại!");
        })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteConceptAttributeType = false;
    }

    resetStore = () => {
        this.searchConceptAttributeType = new SearchObject();
        this.pageConceptAttributeType = null;
        this.selectedConceptAttributeType = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteConceptAttributeType = false;
    }
}